import { Modal, Button, Form, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';

function AddBankAccountModal({ visible, setVisible }) {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log('Received values of form: ', values);
  };

  return (
    <Modal
      title='Reopen Inventory'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      width={500}
      footer={[]}
      className='customModal'
    >
      <Form
        layout='vertical'
        form={form}
        scrollToFirstError
      >
        <Form.Item
          name={'routingNumber'}
          label={'Routing Number'}
          extra="Enter a 9 digit routing number"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'confirmRoutingNumber'}
          label={'Confirm Routing Number'}
          dependencies={['routingNumber']}
          rules={[
            {
              required: true,
              message: 'Please confirm your routing number!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('routingNumber') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The routing number that you entered do not match!'));
              },
            }),
          ]}
          extra="Enter a valid routing number that matches the original routing number above"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'accountNumber'}
          label={'Account Number'}
          extra="Enter a valid accoun number between 4 and 17 digits"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'confirmAccountNumber'}
          label={'Confirm Account Number'}
          dependencies={['accountNumber']}
          rules={[
            {
              required: true,
              message: 'Please confirm your account number!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('routingNumber') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The account number that you entered do not match!'));
              },
            }),
          ]}
          extra="Enter a valid account number that matches the original account number above"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'accountHolder'}
          label={'Account Holder'}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'accountHolderType'}
          label={'Account Holder Type'}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'check'}
          label={'Check #'}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={'signature'}
          label={'Signature'}
        >
          <TextArea />
        </Form.Item>
        <Form.Item
          name={'paymentAccount'}
          label={'Payment Account'}
        >
          <Input />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 20 }}>
          <Form.Item>
            <Button htmlType="button"
              onClick={() => setVisible(false)}
              className='Deactivate-Button'
            >
              Cancel
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className='printButton2'>
              Register
            </Button>
          </Form.Item>
        </div>
      </Form>
    </Modal>
  )
}

export default AddBankAccountModal;
